<template>
  <h1 :id="id" class='assistive-status' tabindex="0" :aria-live="ariaLive" v-html="text"></h1>
</template>

<script>

export default {
  name: 'AssistiveStatus',
  data() {
    return {
       politeInteractionTypes: ['pause_q', 'iframe_q', 'file_viewer_q', 'discussion_q'],
    };
  },
  props: {
    id: String,
    label: String,
    interactionType: String
  },
  computed: {
    text() {
      return this.label || 'Assistive Status';
    },
    ariaLive() {
      return this.politeInteractionTypes.includes(this.interactionType) ? 'polite' : 'assertive';
    },
  },
};
</script>

<style>
 .assistive-status {
   position:absolute;
   left:-15px;
   top:0px;
   z-index:-1;
   opacity:0;
 }
 .assistive-status:focus {
   border: solid red 3px;
 }
</style>
